const sharedAudio = new Audio();

export default sharedAudio;
